import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { DeviceSyncStatusEffects } from './device-sync-status.effects';
import { DeviceSyncStatusReducer, deviceSyncStatusFeatureKey } from './device-sync-status.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(deviceSyncStatusFeatureKey, DeviceSyncStatusReducer),
    EffectsModule.forFeature([DeviceSyncStatusEffects]),
  ],
})
export class DeviceSyncStatusesStoreModule {}
